import factoryLogger from '../../logger/index.js'
import UserServicesFactory from '../../user/Services/factory.js'
import {NewsErrorsFactory} from '../Errors/factory.js'
import NewsRepositoriesFactory from '../Repositories/factory.js'
import {NewsRequestsFactory} from '../Requests/factory.js'
import {NewsServicesFactory} from '../Services/factory.js'
import NewsValueObjectsFactory from '../ValueObjects/factory.js'
import GetFormattedNewsTagUseCase from './GetFormattedNewsTagUseCase.js'
import GetHomeNewsUseCase from './GetHomeNewsUseCase.js'
import {GetModelDetailNewsUseCase} from './GetModelDetailNewsUseCase.js'
import {GetNewsDetailUseCase} from './GetNewsDetailUseCase.js'
import GetNewsSearchUrlUseCase from './GetNewsSearchUrlUseCase.js'
import GetNewsSuggestionsUseCase from './GetNewsSuggestionsUseCase.js'
import GetNewsUseCase from './GetNewsUseCase.js'
import {GetVehicleNewsUseCase} from './GetVehicleNewsUseCase.js'
import {SubscribeToNewsletterUseCase} from './SubscribeToNewsletterUseCase.js'

export default class NewsUseCasesFactory {
  static subscribeToNewsletterUseCase = ({config}) =>
    new SubscribeToNewsletterUseCase({
      config,
      repository: NewsRepositoriesFactory.hTTPNewsRepository({config}),
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      }),
      requestFactory: NewsRequestsFactory.subscribeToNewsletterRequest,
      getSubscribeToNewsletterWithoutEmailError: NewsErrorsFactory.getSubscribeToNewsletterWithoutEmailError
    })

  static getHomeNewsUseCase = ({config}) =>
    new GetHomeNewsUseCase({
      repository: NewsRepositoriesFactory.hTTPNewsRepository({config}),
      log: factoryLogger({prefix: 'GetHomeNewsUseCase'})
    })

  static getModelDetailNewsUseCase = ({config}) =>
    new GetModelDetailNewsUseCase({
      repository: NewsRepositoriesFactory.hTTPNewsRepository({config}),
      log: factoryLogger({prefix: 'GetModelDetailNewsUseCase'})
    })

  static getNewsUseCase = ({config}) =>
    new GetNewsUseCase({
      config,
      repository: NewsRepositoriesFactory.hTTPNewsRepository({config}),
      paginationRepository: NewsRepositoriesFactory.paginationRepository({
        config
      }),
      log: factoryLogger({prefix: 'GetNewsUseCase'})
    })

  static getNewsSearchUrlUseCase = ({config}) =>
    new GetNewsSearchUrlUseCase({
      newsSearchUrlValueObjectFactory: NewsValueObjectsFactory.newsSearchUrlValueObject({
        config
      })
    })

  static getNewsSuggestionsUseCase = ({config}) =>
    new GetNewsSuggestionsUseCase({
      repository: NewsRepositoriesFactory.hTTPNewsRepository({config}),
      log: factoryLogger({prefix: 'GetNewsSuggestionsUseCase'})
    })

  static getFormattedNewsTagUseCase = ({config}) =>
    new GetFormattedNewsTagUseCase({
      formattedNewsTagValueObjectFactory: NewsValueObjectsFactory.formattedNewsTagValueObject({config})
    })

  static getVehicleNewsUseCase = ({config}) =>
    new GetVehicleNewsUseCase({
      getFormattedNewsTagService: NewsServicesFactory.getFormattedNewsTagService({config}),
      getVehicleNewsService: NewsServicesFactory.getVehicleNewsService({config})
    })

  static getNewsDetailUseCase = ({config}) =>
    new GetNewsDetailUseCase({
      config,
      httpNewsRepository: NewsRepositoriesFactory.hTTPNewsRepository({config}),
      newsDetailRequestValueObjectFactory: NewsValueObjectsFactory.newsDetailRequestValueObject
    })
}
